import React, { PureComponent } from 'react';
import ReactToPrint from "react-to-print";
import { PrintIcon } from "../../assets/fontawesome"

class ButtonPrint extends PureComponent {

  state = {
    disabled: true,
  }

  constructor(props) {
    super(props);
    this.enablePrinChat = this.enablePrinChat.bind(this);
  }

  handleClick = (type, e) => {
    this.setState({
      ...this.state,
      disabled: false,
    })
  }

  printChat() {
    const componentRef = document.getElementById("chat-list-messages");
    return (
      <div className="quick-reply-container-3">
        <ReactToPrint
          bodyClass={"message-item"}
          trigger={() =>
            <button title='Imprimir conversa' className="quick-replies eds-style-text hide-print" style={{ display: 'flex' }}>
              <PrintIcon
                style={{ marginRight: "5px" }}
                width="14px"
                color="#2777b8"
                className="print-icon"
              />
              Imprimir Conversa
            </button>}
          content={() => componentRef}
        />
      </div>
    )
  }

  enablePrinChat() {
    if (!this.props.config.isEnablePrintChat) return false;
    return this.props.config.isEnablePrintChat;

  }
  render() {
    if (!this.enablePrinChat()) return false;
    return this.printChat();
  }
}

export default ButtonPrint;